<template>
  <div class="hints-editor-container">
    <div>
      <h1>Add Hint</h1>
    </div>
    <div class="flex items-center items-baseline">
      <label for="hint name">NAME: </label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="name"
          v-validate="'required'"
          name="hint name"
          type="text"
          class="course-create-input"
        />
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("hint name") }}
        </small>
      </div>
    </div>
    <div class="flex items-center items-baseline">
      <label for="hint point">POINTS:</label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="points"
          v-validate="'required|numeric|min_value:1'"
          type="text"
          name="hint point"
          class="course-create-input"
        />
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("hint point") }}
        </small>
      </div>
    </div>
    <div class="flex items-center items-baseline">
      <label>CMS ID:</label>
      <div class="w-full m-2 input-wrapper">
        <input v-model="cms_id" type="text" class="course-create-input" />
      </div>
    </div>
    <div class="flex">
      <div class="w-1/2">
        <div class="block text-center">
          Content
        </div>
        <MarkdownReadingEditor
          v-model="content"
          v-validate="'required'"
          name="hint content"
          uniqueId="edyst-hint-content"
        />
        <small class="err-msg text-red">
          {{ veeValidateErrors.first("hint content") }}
        </small>
      </div>
      <div class="w-1/2">
        <div class="text-center">Preview</div>
        <VueMarkdown
          :source="getRenderedMarkdownToHTML()"
          class="markdown-preview"
        />
      </div>
    </div>
    <div class="small-12 columns">
      <button
        class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-1 hover:bg-green-900"
        @click="addHint"
      >
        Add Hint
      </button>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown"
import siteConfig from "@/utils/siteConfig"
import MarkdownReadingEditor from "@/components/questions/MarkdownReadingEditor"
import markdownHelpers from "@/utils/markdownEditorHelpers"

export default {
  components: { MarkdownReadingEditor, VueMarkdown },
  props: {
    isRoot: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      name: "",
      points: "",
      cms_id: "",
      type: 10,
      content: "",
      markdownRenderer: undefined,
    }
  },
  created() {
    this.markdownRenderer = window.markdownit()
  },
  methods: {
    addHint() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fix the error and try again")
          return
        }
        const data = {
          name: this.name,
          points: this.points,
          cms_id: this.cms_id ? this.cms_id : null,
          type: this.type,
          content: this.content,
        }

        this.axios({
          method: "post",
          url: `${siteConfig.siteURL}questions/`,
          data,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
        })
          .then(response => {
            this.$emit("HINT_CREATED", {
              hintName: response.data.name,
              hintPoints: response.data.points,
              hintId: response.data.id,
            })
            if (this.isRoot) {
              this.$router.push({ name: "HintList" })
            }
            this.$noty.success("Hint was created successfully")
          })
          .catch(err => {
            this.$noty.error(`Failed to create the hint ${err}`)
          })
      })
    },
    getRenderedMarkdownToHTML() {
      return this.markdownRenderer.render(
        markdownHelpers.decodeIDsToMarkdownLinks(this.content, null)
      )
    },
  },
}
</script>

<style scoped>
.is-invalid {
  border-color: #ff5151;
}
.input-wrapper {
  margin: 0.5rem auto;
  margin-left: 2rem;
}
.course-create-input {
  width: 100%;
}
.hints-editor-container {
  width: 98%;
}
</style>
